<!--
일괄기능-반품게시판
------------------------------------

-->
<template>
<div class="">
    
    <!-- 버튼영역 -->
    <div class="uk-text-left">        
        <button 
            class="uk-button uk-button-primary"
            type="button"
            :disabled="disabled"
            v-on:click="$refs.ems.jobInit()"
        >
            <i class="material-icons uk-text-middle" style="font-size: 30px">done</i>
            <span class="uk-text-middle">EMS 송장입력/발송완료</span>
        </button>

        <button 
            class="uk-button uk-button-primary"
            type="button"
            :disabled="disabled"
            v-on:click="$refs.ems_in_wh.jobInit()"
        >
            <i class="material-icons uk-text-middle" style="font-size: 30px">done</i>
            <span class="uk-text-middle">EMS창고도착</span>
        </button>
    </div>
    
    <!-- ems 발송완료 기능 -->
    <ems
        ref="ems"
        :batch="batch"
        :csrfToken="csrfToken"
    ></ems>   
    
    <!-- ems-in-wh 기능 -->
    <ems-in-wh
        ref="ems_in_wh"
        :batch="batch"
        :csrfToken="csrfToken"
    ></ems-in-wh>   
    
</div>
    
</template>

<script>
    Vue.component('ems', require('./ems.vue').default);
    Vue.component('ems-in-wh', require('./ems-in-wh.vue').default);
    export default {
        props: {
            /**
             * 일괄기능 공유data (상세정의는 컨트롤러 참고)
             */
            batch: Object,

            // csrf-token
            csrfToken: String,
        },
        data: function () {
            
            return {
            };
        },
        computed: {
            // 작업 버튼 비활성화 여부
            disabled() {
                // 선택된 아이템없으면 비활성화
                return this.batch.checked_item_count === 0;
            },

        },
        methods: {
        },
    }
</script>

<style lang="scss" scoped>
</style>